import {
  shape,
  string,
  bool,
  object,
  oneOf,
  oneOfType,
  number,
} from 'prop-types';

export const smartFieldInputType = shape({
  as: string,
  type: string, // The HTML input type, which is only relevant if as is 'input' (the default)
  disabled: bool,
  id: string,
  isInvalid: bool,
  isValid: bool,
  plainText: bool,
  readOnly: bool,
  size: oneOf(['sm', 'lg']),
  bsPrefix: string,
});

export const smartFromFieldType = shape({
  input: smartFieldInputType.isRequired,
  name: string.isRequired, // unique value for the level of the form
  initialValue: oneOfType([string, number, bool]).isRequired,
  validation: object,
});
